import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth, authState } from '@angular/fire/auth';
import { map, take } from 'rxjs/operators';

/**
 * Auth Guard
 * Protects routes that require authentication
 * Redirects to /auth/login if user is not authenticated
 *
 * Usage in routes:
 * { path: 'protected', component: ProtectedComponent, canActivate: [authGuard] }
 */
export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(Auth);
  const router = inject(Router);

  return authState(auth).pipe(
    take(1),
    map((user) => {
      // Anonymous sessions exist only for the public Merchant onboarding; they are not
      // an authenticated account and must not unlock protected areas.
      if (user && !user.isAnonymous) {
        return true;
      } else {
        // Store the attempted URL for redirecting after login
        router.navigate(['/auth/login'], {
          queryParams: { returnUrl: state.url },
        });
        return false;
      }
    })
  );
};
